var map = {
	"./arrow.svg": 5719,
	"./arrow0.svg": 9063,
	"./arrow135.svg": 39,
	"./arrow180.svg": 6108,
	"./arrow225.svg": 7168,
	"./arrow270.svg": 7993,
	"./arrow315.svg": 2110,
	"./arrow45.svg": 9345,
	"./arrow90.svg": 8463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1877;